import React from 'react';
import { connect } from 'react-redux';
import { useIdentifyUser } from '../../launchdarkly/userIdentification';

/**
 * Component that identifies the current user to LaunchDarkly
 * This component doesn't render anything, it just connects the Redux user state to LaunchDarkly
 */
const LaunchDarklyUserIdentifier = ({ user }) => {
  // Use the useIdentifyUser hook to update LaunchDarkly with user information
  useIdentifyUser(user);
  
  // This component doesn't render anything
  return null;
};

// Connect to Redux to get the user state
const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps)(LaunchDarklyUserIdentifier);
